module.exports = __webpack_public_path__ + "img/de.ba837178.svg";